import React, { useMemo } from 'react';
import { getIn18Text } from 'api';
import { apiHolder as api, apis } from 'api';
import { useNiceModal } from '@web-common/components/UI/NiceModal/NiceModal';
import ontimeIcon from '@/images/icons/todomail/ontime.svg';
import timeoutIcon from '@/images/icons/todomail/timeout.svg';
import { TASK_MAIL_STATUS } from '../../common/constant';
import './index.scss';
const systemApi = api.api.getSystemApi();
const mailConfApi = api.api.requireLogicalApi(apis.mailConfApiImpl);
const eventApi = api.api.getEventApi();
const TodoMailTip = props => {
    const { content, isDefer, deferTime, deferNotice } = props;
    const mid = useMemo(() => content.id, [content]);
    const taskUndone = useMemo(() => { var _a; return content.taskId && ((_a = content.taskInfo) === null || _a === void 0 ? void 0 : _a.status) === TASK_MAIL_STATUS.PROCESSING; }, [content]);
    const isOverdue = useMemo(() => {
        const timeZone = mailConfApi.getTimezone();
        return systemApi.getDateByTimeZone(deferTime, timeZone) < systemApi.getDateByTimeZone(new Date(), timeZone);
    }, [deferTime]);
    const modal = useNiceModal('mailTodo');
    const _deferTime = useMemo(() => {
        const timeZone = mailConfApi.getTimezone();
        return moment(new Date(systemApi.getDateByTimeZone(deferTime, timeZone))).format('YYYY-MM-DD HH:mm:ss');
    }, [deferTime]);
    const todoChange = () => {
        modal.show({ mailId: mid, isDefer, deferTime, deferNotice });
    };
    const done = () => {
        eventApi.sendSysEvent({
            eventName: 'mailStatesChanged',
            eventData: {
                id: mid,
                isDefer,
                deferTime,
                deferNotice,
            },
            _account: '',
            eventStrData: 'undefer',
        });
    };
    if (!isDefer) {
        return null;
    }
    return (React.createElement("div", { className: "todo-mail-tip" },
        React.createElement("div", null,
            React.createElement("img", { src: isOverdue ? timeoutIcon : ontimeIcon }),
            React.createElement("span", { className: isOverdue ? 'todo-mail-tip-time-overdue todo-mail-tip-time' : 'todo-mail-tip-time' },
                getIn18Text('CHULISHIJIAN'),
                _deferTime.indexOf('2200') !== -1 ? getIn18Text('WEISHEZHI') : moment(_deferTime).format(getIn18Text('MMYUEDD11')),
                ' ',
                _deferTime.indexOf('2200') === -1 && getIn18Text('QIAN')),
            React.createElement("span", { className: "todo-mail-tip-changebtn", hidden: !!taskUndone, onClick: todoChange }, getIn18Text('XIUGAI'))),
        React.createElement("span", { className: "todo-mail-tip-donebtn", hidden: !!taskUndone, onClick: done }, getIn18Text('BIAOWEIYICHULI'))));
};
export default TodoMailTip;
